<template>
    <carousel classes="category-carousel" :items="items" :options="options" :show-navigation="showNavigation">
        <template #slide="{ item }">
            <a :href="item.url" class="categories-item">
                <img v-if="item.image"
                     loading="lazy"
                     class="lazyload"
                     :data-src="item.image"
                     src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAEALAAAAAABAAEAAAICTAEAOw=="
                     :alt="item.name" />
                <span class="icon" v-else v-html="item.icon"></span>
                <span class="categories-title">{{ item.name }}</span>
                <span class="categories-count">{{ item.products_count }} модели</span>
            </a>
        </template>
    </carousel>
</template>

<script>
import Carousel from "./Carousel";
import windowWidth from "../../mixins/windowWidth";

export default {
    name: "Category",
    props: ['items'],
    components: {
        Carousel
    },
    mixins: [
        windowWidth
    ],
    data() {
        return {
            options: {
                loop: true,
                breakpoints: {
                    1200: {
                        slidesPerView: 8,
                    },
                    1024: {
                        slidesPerView: 7,
                    },
                    768: {
                        slidesPerView: 5,
                    },
                    640: {
                        slidesPerView: 4,
                    },
                    320: {
                        slidesPerView: 3,
                    }
                },
            },
        }
    },
    computed: {
        showNavigation() {
            return !this.$q.platform.is.mobile && this.items.length > 3;
        }
    }
}
</script>
